export const navLinks = (t) => [
  { to: "/", label: t.nav.home, id: "home" },
  { to: "/tafakar", label: t.nav.tafaker, id: "tafaker" },
  { to: "/contact", label: t.nav.contact, id: "contact" },
];
